function getPathFromDomainPathReduxUtil (domainPath, domainKeyValue) {
  return `${domainPath}.data.${domainKeyValue}`
}

export default getPathFromDomainPathReduxUtil
